import React, { useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Button, Form } from "reactstrap";
import { PasswordInput } from "components";
import { useTranslate } from "hooks";

type ChangePassViewProps = {
  page: Scrivito.Obj;
};

const ChangePassView = Scrivito.connect(({ page }: ChangePassViewProps) => {
  const translate = useTranslate();
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPassRep, setNewPassRep] = useState("");

  const handleChangePass = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // TODO: No endpoint from DS yet
  };

  const handleOldPasswordChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setOldPass(e.target.value);
    },
    [],
  );
  const handleNewPasswordChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setNewPass(e.target.value);
    },
    [],
  );
  const handleNewPasswordRepChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setNewPassRep(e.target.value);
    },
    [],
  );

  // TODO: temp vars - to remove when we receive the proper endpoint
  const changePassErr = null;
  const isChangePassPending = false;

  return (
    <Form
      className="bg-white col-md-6 mx-auto p-0 d-flex flex-column"
      data-testid="change-pass-view"
      onSubmit={handleChangePass}
    >
      <div className="p-4 font-size-md">
        <Scrivito.LinkTag
          data-testid="ChangePassView_change-pass-link"
          className="text-secondary"
          to={page}
          params={{ view: "changePass" }}
        >
          <span className="fal fa-angle-left"> </span>
          {translate("RESET_VIEW_BACK_TO_LOGIN_BUTTON")}
        </Scrivito.LinkTag>
      </div>
      <div className="col-md-11 mx-auto text-start">
        <h1>{translate("CHANGE_PASSWORD_VIEW_HEADER")}</h1>
        <p>{translate("CHANGE_PASSWORD_VIEW_DESCRIPTION")}</p>
        <PasswordInput
          value={oldPass}
          label={translate("LOGIN_VIEW_OLD_PASSWORD_FIELD_LABEL")}
          error={changePassErr}
          name="oldPassField"
          id="oldPassFieldId"
          testId="oldPass"
          onChange={handleOldPasswordChange}
        />
        <PasswordInput
          value={newPass}
          label={translate("LOGIN_VIEW_NEW_PASSWORD_FIELD_LABEL")}
          error={changePassErr}
          name="newPassField"
          id="newPassFieldId"
          testId="newPass"
          onChange={handleNewPasswordChange}
        />
        <PasswordInput
          value={newPassRep}
          label={translate("LOGIN_VIEW_NEW_PASSWORD_REPEAT_FIELD_LABEL")}
          error={changePassErr}
          name="newPassRepField"
          id="newPassRepFieldId"
          testId="newPassRep"
          onChange={handleNewPasswordRepChange}
          classNames="mb-2"
        />
        <div className="row m-0">
          {changePassErr && (
            <div className="col-md-16 p-0 text-start text-danger">
              {`${translate("LOGIN_VIEW_ERROR_OCCURRED")}: ${changePassErr}`}
            </div>
          )}
          {newPass && newPassRep && newPass !== newPassRep && (
            <p className="col-md-16 p-0 text-start text-danger">
              {translate("LOGIN_VIEW_ERROR_PASSWORD_DIFFER")}
            </p>
          )}
        </div>
        <div className="text-end mt-5 mb-6">
          <Button
            data-testid="ChangePassView_change-pass-btn"
            type="submit"
            color="primary"
            className="ms-3 my-3"
            disabled={isChangePassPending || newPass !== newPassRep}
          >
            {translate("CHANGE_PASSWORD_VIEW_BUTTON")}
          </Button>
        </div>
      </div>
    </Form>
  );
});

export default ChangePassView;
